const KEY = "opg_bio_cred";

const toB64 = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf)));
const fromB64 = (s) => Uint8Array.from(atob(s), (c) => c.charCodeAt(0));
const rand = (n) => crypto.getRandomValues(new Uint8Array(n));

export const biometric = {
  async isSupported() {
    if (!window.PublicKeyCredential?.isUserVerifyingPlatformAuthenticatorAvailable) return false;
    try {
      return await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
    } catch (e) {
      return false;
    }
  },
  isEnabled() {
    return !!localStorage.getItem(KEY);
  },
  async enable(user) {
    const cred = await navigator.credentials.create({
      publicKey: {
        challenge: rand(32),
        rp: { name: "Aurum Gateway", id: window.location.hostname },
        user: {
          id: new TextEncoder().encode(user?.user_id || "merchant"),
          name: user?.email || "merchant",
          displayName: user?.name || "Merchant",
        },
        pubKeyCredParams: [
          { type: "public-key", alg: -7 },
          { type: "public-key", alg: -257 },
        ],
        authenticatorSelection: { authenticatorAttachment: "platform", userVerification: "required" },
        timeout: 60000,
      },
    });
    localStorage.setItem(KEY, toB64(cred.rawId));
  },
  disable() {
    localStorage.removeItem(KEY);
  },
  // Works offline: the phone itself checks the fingerprint
  async verify() {
    const id = localStorage.getItem(KEY);
    if (!id) return false;
    const res = await navigator.credentials.get({
      publicKey: {
        challenge: rand(32),
        rpId: window.location.hostname,
        allowCredentials: [{ type: "public-key", id: fromB64(id), transports: ["internal"] }],
        userVerification: "required",
        timeout: 60000,
      },
    });
    return !!res;
  },
};
